<template>
  <div id="app" class="app-container">
    <AdBanner />
    <HelloWorld />
    <footer class="footer">
      <p>&copy; {{ new Date().getFullYear() }} Assiw清单工具. All rights reserved丨<a href="https://steam.assiw.xyz">steam.assiw.xyz</a></p>
    </footer>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import AdBanner from './components/AdBanner.vue'

export default {
  name: 'App',
  components: {
    HelloWorld,
    AdBanner
  }
}
</script>

<style>
:root {
  --bg-color: #0a0c16;
  --text-color: #f0f2ff;
  --primary-color: #7b68ee;
  --secondary-color: #1a1c2e;
  --accent-color: #c667f8;
  --highlight-color: #5ac8fa;
  --border-color: #232544;
  --card-bg: #131528;
  --tooltip-bg: #1c1e33;
  --info-card-bg: #0f1123;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  --glow-shadow: 0 0 15px rgba(123, 104, 238, 0.4);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  background: linear-gradient(135deg, #090b18 0%, #151b33 100%);
  color: var(--text-color);
  line-height: 1.6;
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
}

body::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    radial-gradient(circle at 10% 10%, rgba(123, 104, 238, 0.05) 0%, transparent 20%),
    radial-gradient(circle at 90% 30%, rgba(198, 103, 248, 0.05) 0%, transparent 20%),
    radial-gradient(circle at 50% 80%, rgba(90, 200, 250, 0.05) 0%, transparent 30%);
  pointer-events: none;
  z-index: 0;
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  z-index: 1;
  animation: fadeIn 0.8s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.footer {
  margin-top: auto;
  padding: 20px;
  text-align: center;
  font-size: 14px;
  color: rgba(240, 242, 255, 0.7);
  border-top: 1px solid var(--border-color);
  background-color: rgba(10, 12, 22, 0.8);
  animation: slideUp 0.6s ease-out;
  position: relative;
  backdrop-filter: blur(10px);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 添加全局过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

/* 添加光效动画 */
@keyframes glow {
  0% {
    box-shadow: 0 0 5px rgba(123, 104, 238, 0.2);
  }
  50% {
    box-shadow: 0 0 20px rgba(123, 104, 238, 0.5);
  }
  100% {
    box-shadow: 0 0 5px rgba(123, 104, 238, 0.2);
  }
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-color);
}

::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--accent-color);
}

/* 全局链接样式 */
a {
  color: var(--highlight-color);
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: var(--accent-color);
}

/* 全局按钮样式 */
button {
  cursor: pointer;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
}

/* 全局输入框样式 */
input, textarea, select {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  color: var(--text-color);
  background-color: var(--secondary-color);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 8px 12px;
  transition: all 0.3s ease;
}

input:focus, textarea:focus, select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 8px rgba(123, 104, 238, 0.4);
}

/* 全局工具提示样式 */
[data-tooltip] {
  position: relative;
}

[data-tooltip]:after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--tooltip-bg);
  color: var(--text-color);
  padding: 5px 10px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  z-index: 10;
  font-size: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

[data-tooltip]:hover:after {
  opacity: 1;
  visibility: visible;
}

/* 超小屏幕适配 */
@media (max-width: 375px) {
  body {
    font-size: 14px;
  }
  
  .footer {
    padding: 10px;
    font-size: 12px;
  }
  
  .footer p {
    word-break: break-word;
  }
  
  input, textarea, select {
    font-size: 14px;
    padding: 6px 10px;
  }
  
  /* 减小全局间距 */
  .app-container {
    padding: 0 5px;
  }
}

/* 针对极小屏幕设备 */
@media (max-width: 320px) {
  body {
    font-size: 13px;
  }
  
  .footer {
    padding: 8px 5px;
    font-size: 11px;
  }
  
  input, textarea, select {
    font-size: 13px;
    padding: 5px 8px;
  }
}
</style> 